import { Link } from 'react-router-dom';

export default function WhyBusinessTraining() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему Business Training
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Business Training — это не просто тренинги. Это система корпоративного развития сотрудников, которая охватывает весь цикл: от диагностики до измеримого результата.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm">
          <div className="grid md:grid-cols-5 gap-6 items-center">
            {/* 5 step boxes */}
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-search-eye-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-1">Диагностика</h3>
              <p className="text-xs text-gray-500">Аудит текущей ситуации и KPI</p>
            </div>

            <div className="hidden md:flex justify-center">
              <i className="ri-arrow-right-line text-2xl text-teal-300"></i>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-book-open-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-1">Обучение</h3>
              <p className="text-xs text-gray-500">Практический тренинг на кейсах</p>
            </div>

            <div className="hidden md:flex justify-center">
              <i className="ri-arrow-right-line text-2xl text-teal-300"></i>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-rocket-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-1">Внедрение</h3>
              <p className="text-xs text-gray-500">Инструменты и регламенты</p>
            </div>

            <div className="hidden md:flex justify-center">
              <i className="ri-arrow-right-line text-2xl text-teal-300"></i>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-user-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-1">Сопровождение</h3>
              <p className="text-xs text-gray-500">Поддержка от 1 до 6 месяцев</p>
            </div>

            <div className="hidden md:flex justify-center">
              <i className="ri-arrow-right-line text-2xl text-teal-300"></i>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-bar-chart-grouped-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-1">Результат</h3>
              <p className="text-xs text-gray-500">Измеримый рост KPI</p>
            </div>
          </div>

          {/* Mobile vertical arrows */}
          <div className="flex md:hidden flex-col items-center gap-0 my-4">
            {[1, 2, 3, 4].map((_, j) => (
              <i key={j} className="ri-arrow-down-line text-xl text-teal-300"></i>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto leading-relaxed">
            В отличие от разовых тренингов, системный подход даёт устойчивый результат. Сотрудники не просто узнают новое — они меняют поведение, а компания получает работающие инструменты на годы вперёд.
          </p>
          <Link
            to="/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie"
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer"
          >
            Узнать о системном подходе
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}